import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgSpeakerOnSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M8.5 1H9.5C9.5 0.589709 9.24938 0.221048 8.86786 0.0701184C8.48634 -0.0808109 8.05133 0.0166197 7.77064 0.315869L8.5 1ZM3.81006 6V7C4.08638 7 4.35038 6.88567 4.53942 6.68413L3.81006 6ZM1 6V5C0.447715 5 0 5.44772 0 6H1ZM1 10H0C0 10.5523 0.447715 11 1 11L1 10ZM3.81006 10L4.53942 9.31587C4.35038 9.11433 4.08638 9 3.81006 9V10ZM8.5 15L7.77064 15.6841C8.05133 15.9834 8.48634 16.0808 8.86786 15.9299C9.24938 15.779 9.5 15.4103 9.5 15H8.5ZM13.5544 3.16777C13.0948 2.86157 12.474 2.98594 12.1678 3.44557C11.8616 3.90519 11.9859 4.52602 12.4456 4.83223L13.5544 3.16777ZM15 7.81006L15.9998 7.83119L15.9999 7.82638L15 7.81006ZM12.3548 11.236C11.9329 11.5923 11.8796 12.2232 12.236 12.6452C12.5923 13.0671 13.2232 13.1204 13.6452 12.764L12.3548 11.236ZM12.55 5.9C12.2186 5.45817 11.5918 5.36863 11.15 5.7C10.7082 6.03137 10.6186 6.65817 10.95 7.1L12.55 5.9ZM12.25 8L13.25 8L12.25 8ZM10.95 8.9C10.6186 9.34183 10.7082 9.96863 11.15 10.3C11.5918 10.6314 12.2186 10.5418 12.55 10.1L10.95 8.9ZM7.77064 0.315869L3.0807 5.31587L4.53942 6.68413L9.22936 1.68413L7.77064 0.315869ZM3.81006 5H1V7H3.81006V5ZM0 6V10H2V6H0ZM1 11H3.81006V9H1V11ZM3.0807 10.6841L7.77064 15.6841L9.22936 14.3159L4.53942 9.31587L3.0807 10.6841ZM9.5 15V1H7.5V15H9.5ZM12.4456 4.83223C12.9318 5.15618 13.329 5.59718 13.6007 6.11469L15.3715 5.18511C14.9443 4.37126 14.3196 3.6775 13.5544 3.16777L12.4456 4.83223ZM13.6007 6.11469C13.8723 6.63217 14.0097 7.20949 14.0001 7.79373L15.9999 7.82638C16.0149 6.90717 15.7987 5.99901 15.3715 5.18511L13.6007 6.11469ZM14.0002 7.78892C13.9863 8.44732 13.8324 9.09497 13.5487 9.68935L15.3536 10.5509C15.7596 9.70039 15.9799 8.77347 15.9998 7.83119L14.0002 7.78892ZM13.5487 9.68935C13.265 10.2838 12.8579 10.8111 12.3548 11.236L13.6452 12.764C14.3653 12.1559 14.9477 11.4013 15.3536 10.5509L13.5487 9.68935ZM10.95 7.1C11.1447 7.35964 11.25 7.67544 11.25 8L13.25 8C13.25 7.2427 13.0044 6.50584 12.55 5.9L10.95 7.1ZM11.25 8C11.25 8.32456 11.1447 8.64036 10.95 8.9L12.55 10.1C13.0044 9.49416 13.25 8.7573 13.25 8H11.25Z"
      fill={props.color}
    />
  </svg>
);

SvgSpeakerOnSmall.displayName = 'SvgSpeakerOnSmall';
const SpeakerOnSmall = withForgeIconProps(SvgSpeakerOnSmall, {
  name: 'SpeakerOn',
  usage: 'Use to indicate audio, or to mute audio.',
  related: 'speaker, sound, volume',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default SpeakerOnSmall;
